import { Pipe, PipeTransform } from '@angular/core';
import { TimeFunctions } from '@campus/utils';

@Pipe({
  standalone: false,
  name: 'time',
})
export class TimePipe implements PipeTransform {
  transform(value: number, addMinuteString?: boolean, showZero?: boolean) {
    return TimeFunctions.getMin(value, addMinuteString, showZero);
  }
}
